import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { NotasComponent } from './Notas.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Notas',
        component: NotasComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Notas',
          nombreFormulario : 'Notas'
        } 
    }
];

@NgModule({
    declarations: [
        NotasComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        NotasComponent
    ]
})

export class NotasModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Notas/Notas.module.ts